import {LinkIcon, MilestoneIcon, Share2Icon, FileTextIcon} from "lucide-react";
import {format} from "date-fns";
import React from "react";
import {getIndicatorColorForStatusCode} from "../../../pages/Traces";
import {Badge} from "../../ui/badge";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "../../ui/tooltip";

export function TraceIdTitle(props: {
    serviceName: string
    method: string,
    path: string,
    traceId: string,
    linkedTraceId?: string,
    spans?: any[]
}) {
    const prefix = props.method == "" || props.method == "N/A" ? "" : "[" + props.method.toUpperCase() + "]  "
    const fullPath = prefix + props.path

    return <div className={"flex justify-items-end relative"}>
        <div className="w-[350px] h-full flex-col justify-start items-start inline-flex">
            <div className="justify-start items-center gap-1 inline-flex">
                <MilestoneIcon className="text-secondary w-8 h-[42px] relative"/>
                <div className="pb-[8px] self-stretch flex items-center gap-2 sm:max-w-[500px] md:max-w-[600px] lg:max-w-[700px] xl:max-w-[900px] 2xl:max-w-[1000px]">
                    <div
                        className="text-textdark text-sm font-semibold leading-tight truncate">{props.serviceName}</div>
                    <div className="text-blue-500 text-sm font-semibold leading-tight flex-shrink-0">&gt;&gt;</div>
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <div
                                    className="text-textdark text-sm font-semibold leading-tight truncate">{fullPath}</div>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p className="text-textmedium">{fullPath}</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 w-full">
                <div className="flex items-center">
                    <div className="bg-backgrounddark rounded-tl rounded-bl border border-secondary py-1.5 px-2 w-max">
                        <div className="text-center text-textmedium text-sm font-medium">
                            {props.linkedTraceId ? "eBPF traceId" : "traceId"}
                        </div>
                    </div>
                    <div
                        className="bg-backgroundlight rounded-tr rounded-br border-r border-t border-b border-secondary py-1.5 px-2 w-max">
                        <div className="text-center text-textlight text-sm font-medium">
                            {props.traceId}
                        </div>
                    </div>
                    {props.linkedTraceId && (
                        <div className="flex items-center">
                            <div className="flex items-center">
                                <div className="flex items-center mx-1 text-primary">
                                    <LinkIcon className="w-4 h-4"/>
                                </div>
                                <div
                                    className="bg-backgrounddark rounded-tl rounded-bl border border-primary py-1.5 px-2 w-max">
                                    <div className="text-center text-textmedium text-sm font-medium">
                                        OTel traceId
                                    </div>
                                </div>
                                <div
                                    className="bg-backgroundlight rounded-tr rounded-br border-r border-t border-b border-primary py-1.5 px-2 w-max">
                                    <div className="text-center text-textlight text-sm font-medium">
                                        {props.linkedTraceId}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
}

export function TraceRequestResultDetails(props: {
    datetime: number,
    statusCode: string,
    statusMessage: string,
    duration: number,
    handleCopyDeeplink: () => void,
    handleViewLogs?: () => void,
    logsDisabled?: boolean
}) {
    const indicatorColor = getIndicatorColorForStatusCode(props.statusCode);
    return (<div className={"flex flex-col items-end gap-4"}>
            <div className="flex gap-2">
                <div
                    className={"flex gap-1 items-center w-max border border-primary bg-primarytransparent px-2 py-1 rounded hover:text-textlight text-textmedium hover:cursor-pointer"}
                    onClick={props.handleCopyDeeplink}
                >
                    <Share2Icon className="w-4 h-4"/>
                    Share Trace
                </div>
                {props.handleViewLogs && (
                    <div
                        className={`flex gap-1 items-center w-max border border-primary bg-primarytransparent px-2 py-1 rounded text-textmedium ${
                            props.logsDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:text-textlight hover:cursor-pointer'
                        }`}
                        onClick={props.logsDisabled ? undefined : props.handleViewLogs}
                    >
                        <FileTextIcon className="w-4 h-4"/>
                        View Logs
                    </div>
                )}
            </div>
            <div className="flex items-center gap-4">
                <Badge
                    className={"text-textlight rounded " + indicatorColor}>{props.statusCode} {props.statusMessage}</Badge>
                <div className="text-textdark text-sm font-medium leading-[14px]">|</div>
                <div
                    className="text-textdark text-sm font-medium leading-[14px]">{format(new Date(props.datetime), "PPpp")}</div>
            </div>
        </div>
    );
}
